// SignupButton.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './SignupButton.css';

/**
 * SignupButton
 * 
 * Button component for user signup.
 *  
 * @param {object} image - The image source for the button icon.
 * @param {string} label - The text label for the button.
 *  
 * @returns {ReactNode} - SignupButton.
 */
const SignupButton = React.memo(({ image, label, onClick }) => {

    // ------ CONTEXT ------ //

    const { theme } = useTheme();

    // ------ RENDER ------ //

    return (

        <div
            className="signup-button-container"
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(e) => {
                if (!onClick) return;
                if (e.key === 'Enter' || e.key === ' ') onClick(e);
            }}>

            {/* SIGNUP BUTTON ICON */}
            <div className="signup-button-icon"
                style={{
                    backgroundColor: theme.backgroundMuted
                }}>

                {/* GOOGLE ICON */}
                <img
                    className="signup-button-icon-image"
                    src={image}
                    alt={label}
                />

            </div>

            {/* SIGNUP BUTTON TEXT */}
            <div className="signup-button-text"
                style={{
                    color: theme.foreground
                }}>
                {label}
            </div>

        </div>
    );

});

// Dev Tools
SignupButton.displayName = 'SignupButton';

export default SignupButton;

